/**
 * Friendly display names for ZSP claims-made coverage component codes.
 * Shared across the renewal summary and tail (ERP) UI so both surfaces show
 * the same name for the same code — add new codes here rather than in a
 * per-feature copy.
 */
export const ZSP_COMPONENT_LABELS: Record<string, string> = {
  ZSP_DNO: 'Directors and Officers',
  ZSP_EPL: 'Employment Practices Liability',
  ZSP_FIDUCIARY: 'Fiduciary',
  ZSP_CRIME: 'Crime',
};

export const componentLabel = (key: string) => ZSP_COMPONENT_LABELS[key] ?? key;

/** A row's product lines by name, comma separated; empty when it has none. */
export const joinComponentLabels = (row: {
  readonly componentKeys?: readonly string[];
}) => (row.componentKeys ?? []).map(componentLabel).join(', ');
